import React from 'react';
import PropTypes from 'prop-types';
import styles from './styles.module.scss';
import Modal from 'react-modal';
import ProgressBar from 'common/components/ProgressBar';

const customStyles = {
  content: {
    top: '20%',
    left: '50%',
    right: 'auto',
    bottom: 'auto',
    marginRight: '-50%',
    transform: 'translate(-50%, -50%)',
    backgroundColor: 'white',
    width: '500px',
    height: '200px'
  },
  overlay: {
    backgroundColor: 'rgba(0, 0, 0, 0.25)'
  }
};

const ModalTabuYashirRequestPending = ({
                                         isOpen,
                                         close,
                                         progress
                                       }) => {

  return (
    <Modal
      isOpen={isOpen}
      style={customStyles}
      onRequestClose={close}
    >
      <div className={styles.serverRequestModalContent}>
        <h2 className={styles.header}>שליפה וניתוח של נסח טאבו</h2>
        <div className={styles.progressBarContainer}>
          <ProgressBar progress={progress}/>
        </div>
        <p className={styles.statePending}>בבקשה המתינו לסיום הפעולה</p>
      </div>
    </Modal>
  );
};

ModalTabuYashirRequestPending.propTypes = {
  isOpen: PropTypes.bool,
  close: PropTypes.func,
  progress: PropTypes.number
};

export default ModalTabuYashirRequestPending;
